import { executeSupabaseEdgeFunction } from ".";

export type GasResponse<T> = GasSuccessResponse<T> | GasErrorResponse;

export interface GasSuccessResponse<T> {
  status: "success";
  data: T;
}

export interface GasErrorResponse {
  status: "error";
  data: GasErrorResponseData;
}

export interface GasErrorResponseData {
  message: string;
  requestParams: Record<string, string>;
  postData?: AppsScriptHttpRequestEventPostData;
  cause: string;
}

// NOTE: This must match the type defined in google-apps-script-events.d.ts, but we don't want to bring the entire
// GoogleAppsScript namespace into this project, since it is used in browser-side code.
export interface AppsScriptHttpRequestEventPostData {
  length: number;
  type: string;
  contents: string;
  name: string;
}

export interface GasLongRunningStatusCompleteResponse<T> {
  status: "completed";
  progressMessage: string | null;
  data: GasResponse<T>;
}

export async function startLongRunningGASRequest(
  gasApiMethod: string,
  queryParams?: URLSearchParams | string | Record<string, string>,
  body?: BodyInit,
): Promise<string> {
  const response = await executeSupabaseEdgeFunction<{ requestId: string }>(
    `api/gas/long-running/${gasApiMethod}?${new URLSearchParams(queryParams)}`,
    {
      method: "POST",
      body,
    },
  );
  return response.requestId;
}

export async function getLongRunningGASRequestStatus<T = unknown>(requestId: string): Promise<GasResponse<T>> {
  const response = await executeSupabaseEdgeFunction<GasLongRunningStatusCompleteResponse<T>>(
    `api/gas/long-running/status/${requestId}`,
  );
  return response.data;
}
